import React from "react";
import "./aboutMe.css";

const AboutMe = () => {
    return (
        <div className={"aboutMe"} id={"aboutMe"}>
            <h1 className={"aboutMe-heading"}>AboutMe</h1>
            <div className={"aboutme-top"}>
                <div className={"circle circle-1"}/>
                <div className={"circle circle-2"}/>
                <div className={"circle circle-3"}/>
            </div>
            <div className={"aboutMe-content"}>
                <p className={"aboutMe-detail"}>
                    About Mrigank $ Hello, my name is Mrigank Anand. I am a Computer Science Student from
                    National Institute of technology Hamirpur.
                    I love problem solving and working on challenging projects. Looking for better opportunities.
                </p>
                <p className={"aboutMe-detail"}>
                    I have worked as a Backend Developer and Full Stack Developer roles as interns. Looking for more
                    opportunities to work on some challenging projects.
                    I love Cricket, TV Series and movies.
                </p>
                <p className={"aboutMe-detail"}>
                    I am a active participant on <a href={"https://www.codechef.com/users/mgk25"}
                                                    target={"_blank"}>CodeChef</a> and <a
                    href={"https://leetcode.com/spiderxm/"} target={"_blank"}>LeetCode</a>.
                </p>

                <p className={"aboutMe-detail"} style={{display: "block"}}>
                    You can find more about me from my <a
                    href={"https://pdfhost.io/v/9YWY4Jkac_Mrigank_Anand_Resumepdf.pdf"} target={"_blank"}>Resume</a>
                </p>
            </div>
        </div>
    );
}
export default AboutMe;